import React from 'react';
import PropTypes from 'prop-types';

import Translate, { useI18n } from '@hydra/common/components/i18n';
import ReviewSkeleton from '@hydra/common/components/ReviewSkeleton';
import CriteriumChart from '@hydra/common/criterium/CriteriumChart';
import Criterium from '@hydra/common/criterium/Criterium';
import CriteriumText from '@hydra/common/criterium/CriteriumText';

export const PjFbInsightEngagement = ({ criterium }) => {
  const { translate, moment } = useI18n();
  if (!criterium) {
    return (
      <Criterium criterium={{ type: 'pj_fb_insight_engagement', score: null, importance: 0, solvability: 0 }} clickable={false}>
        <ReviewSkeleton height={366} />
      </Criterium>
    );
  }

  const { data } = criterium;

  const likes = data.fan_adds_unique;
  const activity = data.content_activity;
  const negative = data.negative_feedback_unique;
  const checkins = data.places_checkin_mobile_unique;

  const chartData = [
    {
      name: translate('pj_so_fan_adds_unique'),
      data: likes.map(([timestamp, value]) => {
        return ({
          day: moment(timestamp).format('D MMM'),
          x: timestamp,
          y: value
        });
      })
    },
    {
      name: translate('pj_so_stories'),
      data: activity.map(([timestamp, value]) => {
        return ({
          day: moment(timestamp).format('D MMM'),
          x: timestamp,
          y: value
        });
      })
    },
    {
      name: translate('pj_so_negative_feedback_unique'),
      data: negative.map(([timestamp, value]) => {
        return ({
          day: moment(timestamp).format('D MMM'),
          x: timestamp,
          y: value
        });
      })
    },
    {
      name: translate('pj_so_places_checkin_mobile_unique'),
      data: checkins.map(([timestamp, value]) => {
        return ({
          day: moment(timestamp).format('D MMM'),
          x: timestamp,
          y: value
        });
      })
    }
  ];

  const metricsData = [likes, activity, negative, checkins];

  const allSeriesEmpty = metricsData
    .every(series => series.every(dataPoint => dataPoint[1] <= 0));

  return (
    <Criterium criterium={criterium}>
      {allSeriesEmpty && <CriteriumText firstLine={<Translate content='pj_facebook_missing_metrics_data' />} />}
      <CriteriumChart type='line' data={chartData} hasLegend hasTooltip frequency='day' />
    </Criterium>
  );
};

PjFbInsightEngagement.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      fan_adds_unique: PropTypes.array,
      stories: PropTypes.array,
      negative_feedback_unique: PropTypes.array,
      places_checkin_mobile_unique: PropTypes.array
    })
  })
};

export default React.memo(PjFbInsightEngagement);
